import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {MembershipTypeEntityModel} from "../membership-type-entity.model";
import {FormGroup} from "@angular/forms";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {PointsData} from "../../points/points.data";

@Component({
    selector: "wbo-membership-type-edit-page",
    templateUrl: "./membership-type-edit-page.component.html",
    providers: [(provideEntityModel(MembershipTypeEntityModel))]
})
export class MembershipTypeEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;

    constructor(public model: MembershipTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService, false);
    }

    get isAccrualRewardRateValueReadOnly(): boolean {
        return this.model.data.accrualRewardRate.rewardRate.type === PointsData.TYPE_NONE;
    }

    get isRedemptionRewardRateValueReadOnly(): boolean {
        return this.model.data.redemptionRewardRate.rewardRate.type === PointsData.TYPE_NONE;
    }

    accrualTypeChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        this.updateValueAndValidity(["accrualRewardRate.rewardRate.value"]);
    }

    redemptionTypeChanged({value, dataItem, formGroup}: { value: any, dataItem: any, formGroup: FormGroup }): void {
        this.updateValueAndValidity(["redemptionRewardRate.rewardRate.value"]);
    }
}
